import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingModule } from '../loading/loading.module';
import { ChecklistSaveComponent } from './components/checklist-save/checklist-save.component';
import { ValidationChecklistComponent } from './validation-checklist.component';


@NgModule({
    imports: [
        CommonModule,
        LoadingModule
    ],
    declarations: [
        ValidationChecklistComponent,
        ChecklistSaveComponent
    ],
    exports: [
        ValidationChecklistComponent,
        ChecklistSaveComponent
    ]
})
export class ValidationChecklistModule {
}
